<template>
    <div class="formulario-pedido">
        <div class="row">
            <div class="col m6 s12" style="margin-bottom: 20px;">
                <label for="pedido_plataforma_origem">
                    Plataforma de origem
                </label>
                <select
                    class="browser-default"
                    id="pedido_plataforma_origem"
                    v-model="formData.plataforma_origem"
                >
                    <option value="" selected disabled>Selecione ...</option>
                    <option value="1">Segasp Univalores</option>
                    <option value="2">Própria</option>
                </select>
            </div>
            <div class="col m6 s12" style="margin-bottom: 20px;">
                <label for="pedido_plataforma_origem">
                    Estágio
                </label>
                <select
                    class="browser-default"
                    id="pedido_plataforma_origem"
                    v-model="formData.pedido_estagio_id"
                >
                    <option value="" selected>Selecione ...</option>
                    <option
                        :key="pedidoEstagio.pedido_estagio_id"
                        :value="pedidoEstagio.pedido_estagio_id"
                        v-for="pedidoEstagio in pedidoEstagios"
                    >
                        {{ pedidoEstagio.pedido_estagio_nome }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
import { get } from "@/helpers/api";

export default {
    props: ["pedido"],
    data: () => ({
        formData: {
            plataforma_origem: 1,
            pedido_estagio_id: '',
        },
        pedidoEstagios: []
    }),
    methods: {
        getPedidoEstagios() {
            get("pedido-estagio").then(res => {
                this.pedidoEstagios = res.data.result.data;
            });
        }
    },
    async created() {
        if (this.pedido) {
            this.formData.plataforma_origem = this.pedido.plataforma_origem;
            this.formData.pedido_estagio_id = this.pedido.pedido_estagio_id;
        }

        this.getPedidoEstagios();
    },
    watch: {
        formData: {
            handler: function() {
                this.$emit("newdata", [
                    this.formData.plataforma_origem,
                    this.formData.pedido_estagio_id,
                ]);

                this.$emit("input", this.formData);
            },
            deep: true
        }
    }
};
</script>

<style>
.formulario-pedido.step-parent {
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormularioPedido.vue